import type { FlowState } from './types.js';
/** The L1 model's own seeded stream: a 32-bit LCG, so Node, worker and fixture runs agree exactly. */
export function randomInteger(state: Pick<FlowState, 'randomState'>, min: number, max: number): number {
    state.randomState = (Math.imul(state.randomState, 1664525) + 1013904223) >>> 0;
    return min + Math.floor(state.randomState / 4294967296 * (max - min + 1));
}
